import React, { FunctionComponent } from 'react';
import { ThemeProvider } from 'styled-components';

import defaultTheme from '@savgroup-front-common/core/theme/defaultTheme';
import {
  generateColorsNewUI,
  Theme,
} from '@savgroup-front-common/core/theme/Theme';

import { useSellerTheme } from '../../hooks';
import { useClientInformationContext } from '../atoms';

const MyAccountThemeContainer: FunctionComponent<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const { clientInformation } = useClientInformationContext();

  const { theme } = useSellerTheme({
    sellerId: clientInformation?.sellerId || clientInformation?.tenantId,
  });

  const newUI = generateColorsNewUI(theme);

  const themeCustom = {
    ...theme,
    newUI: {
      ...(theme?.newUI ?? {}),
      defaultColors: newUI?.defaultColors,
      variationColors: {
        ...(theme?.newUI?.variationColors ?? {}),
        light3: theme && theme.colors.default,
      },
      inputBorderColors: {
        ...(theme?.newUI?.inputBorderColors ?? {}),
        default: theme?.colors.default,
      },
    },
    flexboxgrid: {
      gutterWidth: 2,
      outerMargin: 0,
    },
    components: {
      ...(theme?.components ?? {}),
      defaultLabel: {
        ...(theme?.components?.defaultLabel ?? {}),
        fontSize: '14px',
        fontWeight: '600',
        color:
          theme?.colors?.paragraphTextColor ??
          defaultTheme.colors.paragraphTextColor,
        lineHeight: '16px',
      },
    },
  };

  return <ThemeProvider theme={Theme(themeCustom)}>{children}</ThemeProvider>;
};

export default MyAccountThemeContainer;
